import "./section-sub-heading-component-styles.scss";

const SectionSubHeadingComponent = ({ text, icon }) => {
	return (
		<h4 className="sub-heading">
			<span className="section-icon-box">
				{icon}
			</span>{" "}
			{text}
		</h4>
	);
};

export default SectionSubHeadingComponent;
